<template>
  <div class="main-Bar" ref="mainBar">
    <div class="dark-fon"></div>
    <div class="first-spacer">
      <ImageContainer
        :src="list.image?.large"
        :thumb="list.image?.thumbnail"
        :alt="list.title"
        :ignoreError="true"
        ref="fade_carousel"
      />
      <div class="linear-gradient top"></div>
      <div class="linear-gradient bottom"></div>
      <div class="content-wrapper">
        <div class="left">
          <transition name="fromtop" appear>
            <div class="date">
              <span class="day">{{ handleDate(list.pub_date, "dd") }}</span>
              <span class="month">{{ handleDate(list.pub_date, "mmmm") }}</span>
            </div>
          </transition>
          <transition name="fromtop" appear>
            <router-link
              :to="
                $i18nRoute({
                  name: 'NewsDetail',
                  params: { slug: list.url }
                })
              "
              class="category"
            >
              <span class="cat">{{ list.sub_category.name }}</span>
            </router-link>
          </transition>
          <transition name="fromleft" appear>
            <router-link
              :to="
                $i18nRoute({
                  name: 'NewsDetail',
                  params: { slug: list.url }
                })
              "
              class="title"
            >
              {{ list.title }}
            </router-link>
          </transition>
          <div class="btn">
            <transition name="fromleft" appear>
              <router-link
                :to="
                  $i18nRoute({
                    name: 'NewsDetail',
                    params: { slug: list.url }
                  })
                "
                class="flat-btn"
              >
                {{ $t("main.more") }}
              </router-link>
            </transition>
          </div>
        </div>
        <div class="center"></div>
      </div>
      <div class="collar-wrapper">
        <div class="collar-spacer"></div>
      </div>
    </div>
  </div>
</template>

<script>
import ImageContainer from "@/components/ImageContainer";
import { useFormatter } from "@/utils/formatter";
import { ref } from "vue";
import { onBeforeUnmount, onMounted } from "vue";

export default {
  name: "DefaultMainBar",
  components: {
    ImageContainer
  },
  props: {
    list: {
      type: Object,
      required: true
    }
  },
  setup() {
    const mainBar = ref(null);
    const mainPosition = () => {
      if (window.innerWidth > 978) {
        mainBar.value.children[0].style.background = `rgba(0,0,0,${(window.pageYOffset *
          window.innerWidth) /
          1200000})`;
        mainBar.value.children[0].style.backdropFilter = `blur(${(window.pageYOffset *
          window.innerWidth) /
          120000}px)`;
      }
      if (window.pageYOffset > 2000) {
        mainBar.value.style.opacity = "0";
      } else {
        mainBar.value.style.opacity = "1";
      }
    };

    onMounted(() => {
      window.addEventListener("scroll", mainPosition);
      mainPosition();
    });

    onBeforeUnmount(() => {
      window.removeEventListener("scroll", mainPosition);
    });

    return {
      mainBar,
      mainPosition,
      ...useFormatter()
    };
  }
};
</script>

<style lang="scss" scoped>
.main-Bar {
  width: 100%;
  position: fixed;

  .dark-fon {
    display: none;
    pointer-events: none;
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0);
    z-index: 2;
  }
  .first-spacer {
    position: relative;
    width: 100%;
    height: 100vh;
    // max-height: 1500px;
  }
  .linear-gradient {
    display: none;
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 100%;
    pointer-events: none;
    background: linear-gradient(
      180deg,
      rgba(18, 18, 18, 0.5) 0%,
      rgba(0, 0, 0, 0) 92.49%
    );

    // &.top {
    //   background-image: linear-gradient(var(--background-color), transparent);
    //   opacity: 0.2;
    // }

    // &.bottom {
    //   background-image: linear-gradient(transparent, var(--background-color));
    // }
  }
  .content-wrapper {
    --top-offset: calc(145px);
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    top: var(--top-offset);
    width: 90%;
    height: calc(100% - var(--top-offset));
    display: flex;

    .left {
      width: 40%;
      height: 100%;
      color: var(--primary-font-color);
      font-family: Open Sans;
      display: flex;
      flex-direction: column;
      .date {
        .day {
          font-size: 6em;
        }
        .month {
          font-size: 4em;
          padding-left: 0.5em;
          text-transform: lowercase;
        }
      }
      .category {
        text-transform: uppercase;
        padding-top: 1.25rem;
        .cat {
          font-weight: 600;
          font-size: 4em;
          transition: all 0.2s ease;
          margin-right: 1.25em;
          cursor: pointer;
          &:hover {
            color: lightgray;
          }
        }
        .sub-cat {
          transition: all 0.2s ease;
          cursor: pointer;
          &:hover {
            color: lightgray;
          }
        }
      }
      .title {
        --snup: 5;
        display: -webkit-box;
        -webkit-line-clamp: var(--snup);
        -webkit-box-orient: vertical;
        overflow: hidden;
        margin: 1.875rem 0;
        letter-spacing: 0.05em;
        font-size: 4em;
        cursor: pointer;
        transition: all 0.2s ease;
        font-family: "Roboto", serif;
        &:hover {
          // color: lightgray;
        }
      }
      .btn {
        display: flex;
        font-size: 2.5em;
      }
    }
  }
}
@media screen and (max-width: 2900px) {
  .main-Bar {
    .content-wrapper {
      width: var(--main-wrapper-width);
      .left {
        width: var(--left-width);
        .date {
          .day {
            font-size: 3em;
          }
          .month {
            font-size: 1.75em;
          }
        }
        .category {
          .cat {
            font-size: 1.125em;
          }
        }
        .title {
          font-size: 2.5em;
        }
        .btn {
          font-size: 1.7em;
        }
      }
    }
  }
}
@media screen and (max-width: 1920px) {
  .main-Bar {
    .dark-fon {
      display: block;
    }
    .first-spacer {
      max-height: 1500px;
    }
    .linear-gradient {
      display: block;
    }
    .content-wrapper {
      width: var(--main-wrapper-width);
      .left {
        width: var(--left-width);
        .date {
          .day {
            font-size: 3em;
          }
          .month {
            font-size: 1.75em;
          }
        }
        .category {
          .cat {
            font-size: 1.125em;
          }
        }
        .title {
          font-size: 2.5em;
        }
        .btn {
          font-size: inherit;
        }
      }
    }
  }
  @media screen and (max-width: 978px) {
    .main-Bar {
      position: relative;

      .dark-fon {
        display: none;
      }
      .first-spacer {
        height: auto;

        .content-wrapper {
          z-index: 3;

          .left {
            position: relative;
            z-index: 3;
            .title {
              --snup: 3;
            }
            .btn {
              display: none;
            }
          }
        }
      }
    }
  }
}

@media screen and (max-width: 978px) {
  .main-Bar {
    position: relative;
    &::before {
      content: "";
      position: absolute;
      bottom: 0;
      left: 0;
      width: 100%;
      height: 34%;
      background: #163346;
      background: rgb(45, 109, 112);
      background: linear-gradient(
        0deg,
        rgb(24, 49, 72) 60%,
        rgba(45, 109, 119, 0) 100%
      );
      z-index: 2;
    }
    .dark-fon {
      display: none;
    }
    .first-spacer {
      height: auto;
      height: 40vh;
      .content-wrapper {
        .left {
          .title {
            --snup: 3;
          }
          .btn {
            display: none;
          }
        }
      }
    }
  }
}
@media screen and (max-width: 768px) {
  .main-Bar {
    padding-bottom: 3rem;
    // background: #2D6D77;
    // width: 100%;
    // height: 100%;

    .first-spacer {
      height: auto;
      height: 30vh;
      // aspect-ratio: 140/79;
      .content-wrapper {
        --top-offset: calc(85px);
        .left {
          .date {
            font-weight: 600;
            .day {
              font-size: 2em;
            }
            .month {
              font-size: 1.5em;
            }
          }
          .category {
            padding-top: 0.5rem;
            .cat {
              font-size: 1em;
            }
          }
          .title {
            position: absolute;
            bottom: -1.5rem;
            --snup: 2;
            font-size: 1.8em;
          }
        }
      }
    }
  }
}
@media screen and (max-width: 475px) {
  .main-Bar {
    padding-bottom: 4rem;
    .first-spacer {
      .content-wrapper {
        --top-offset: calc(65px);
        .left {
          .date {
            .day {
              font-size: 1.8em;
            }
            .month {
              font-size: 1.4em;
            }
          }
          .category {
            padding-top: 0.5rem;
            .cat {
              font-size: 1em;
              margin-right: 0;
              margin-left: 0.5rem;
            }
          }
          .title {
            position: absolute;
            bottom: -1.5rem;
            --snup: 2;
            font-size: 1.5em;
            margin: 7rem 0.5rem 0 0.5rem;
          }
        }
      }
    }
  }
}
</style>
